<template>
    <div class="w-root off-canvas-wrapper">
        <div class="off-canvas-content w-views" data-off-canvas-content>
            <vue2-gesture :type="'swipeLeft'" :call="handleGesture.bind(this, 'swipeLeft')">
                <vue2-gesture :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
                    <div id="application-wrapper">
                        <transition :name="'fade'" mode="out-in">
                            <header v-if="navbarVisible">
                                <div class="user-box" v-if="profile.id"
                                    @click="toggleProfileSidebar(null)"
                                    :class="{'online': !discreetModeEnabled, 'meet_now': meetNowStatus}">
                                    <div class="img" :style="{'background': `url(${defaultPhoto}) no-repeat center / cover`}"></div>
                                </div>
                                <div class="buttons">
                                    <div class="button mask"
                                        v-if="userIsPro"
                                        :class="{'active': discreetModeEnabled}"
                                        @click="trySwitchDiscreetMode">
                                    </div>
                                    <div dusk="meet-now" id="meet_now"
                                         class="button meet_now"
                                         :class="{'active': meetNowStatus,'active_pro': meetNowStatus && userIsPro}"
                                         @click="toggleMeetNow">
                                      <span v-if="meetNowStatus && userIsPro" >{{meet_now_text}}</span>
                                    </div>
                                    <div dusk="notifications-page" id="visits"
                                        class="button visits"
                                        :class="{'active': tab === 'chat', 'notificated': userHasNotifications}"
                                        @click="!profile.id ? goTo('/visitors') : goTo('/notifications')">
                                        <div class="notificated-icon" v-if="userHasNotifications"></div>
                                    </div>
                                    <div v-if="!profile.id" dusk="register-button" class="register-button-container">
                                      <button @click="goToRegisterPage" class="btn btn-primary button-create-account">{{trans("home.create_account")}}</button>
                                    </div>
                                    <div dusk="discover-filters" id="filter"
                                        :class="{'activated': enabledFiltersCount}"
                                        @click="toggleFilterSidebar(null)"
                                         v-if="!searchBuddyInput.length"
                                        class="button filter">
                                        <span class="quantity" v-if="enabledFiltersCount">{{ enabledFiltersCount }}</span>
                                    </div>
                                </div>
                            </header>
                        </transition>

                        <div class="mobileSidebarHolder positionLeft"
                             :class="{'active': sidebar.profile.visible}">
                            <div class="mobileSidebarHide" @click="toggleProfileSidebar(false)"></div>
                            <div class="mobileSidebar">
                                <ProfileMenu/>
                            </div>
                        </div>

                        <div class="mobileSidebarHolder positionRight"
                             :class="{'active': sidebar.filter.visible}">
                            <div class="mobileSidebarHide" @click="toggleFilterSidebar(false)"></div>
                            <div class="mobileSidebar">
                                <FiltersForms v-on:disableSwipe="setDisableSwipe"/>
                            </div>
                        </div>

                        <div id="content-wrapper-wrapper" class="content-wrapper" @scroll="prepareScroll($event)" ref="mobileScrollTopContainer">
                          <div id="js-search-content" class="content-wrapper search-menu" v-if="showSearchInput">
                            <div class="box">
                              <div class="search">
                                <input
                                    type="text"
                                    :placeholder="trans('main_search_users')"
                                    v-model="searchBuddyInput"
                                    name="searchInput"
                                    ref="searchBuddy"
                                    @input="searchBuddyDebounce"
                                    :class="{searchTagInputActive:searchTagInputActive}"
                                    @keypress.enter.prevent="searchBuddy()">
                                <input type="submit" class="submit" @click="searchBuddy()" v-if="!searchBuddyInput.length">
                                <div class="close searchClose" @click="cleanSearch()" v-if="searchBuddyInput.length"></div>
                                <div class="searchTagsParent" v-if="canShowTagsBlock">
                                  <vue-custom-scrollbar class="searchTagsChild discoverSearchTagsChild">
                                    <div class="searchTag" v-for="tag in searchTags">
                                      <a href="javascript:void(0);" @click="fillTag(tag)">#{{ tag.name }}</a>
                                    </div>
                                    <div class="searchTag" v-if="!searchTags.length && !tagsLoading">
                                      <span>Tags not found</span>
                                    </div>
                                    <div class="searchTag" v-if="tagsLoading">
                                      <span>...</span>
                                    </div>
                                  </vue-custom-scrollbar>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearBothDiscoverSearch" v-if="showSearchInput"></div>


                            <div @touchstart="stopOnlineFavoriteRefresh = true" @touchend="stopOnlineFavoriteRefresh = false" class="favorites" v-if="(!meetNowStatus || !meetNowUsers || !meetNowUsers.length) && !searchBuddyInput.length && showFavoriteOnline && profile.id">
                                <div class="h1">{{ trans('favorites_online') }}</div>
                                <div id="favoritesonline_container" class="faces" @scroll="onScroll">
                                    <div class="face" v-for="favorite in favoritesOnline"
                                        :dusk="'favorite-online-'+favorite.id" href="javascript:void(0)"
                                        v-on:click="goToProfile(favorite)"
                                        :class="{'meet_now': favorite.meet_now,'online': favorite.isOnline || (user.meet_now && user.id === profile.id), 'was-online': favorite.wasRecentlyOnline && !favorite.isOnline, 'default-photo': favorite.photo_small === '/assets/img/default_180x180.jpg', 'sensitive': favorite.photo_small === '/assets/img/toohot_180x180.jpg'}">
                                        <div class="img" :style="{'background': `url(${favorite.deleted_at ? trashIcon : favorite.photo_small}) no-repeat center / cover`}"></div>
                                        <div class="details">
                                            <div class="name notranslate">{{ favorite.headline }}</div>
                                        </div>
                                    </div>
                                  <infinite-loading
                                      ref="infiniteLoadingFavorites"
                                      force-use-infinite-wrapper="#favoritesonline_container"
                                      @infinite="loadOnlineUsers"
                                      :distance="800"
                                      direction="right"
                                      spinner="bubbles">
                                    <span slot="no-more"></span>
                                    <span slot="no-more"></span>
                                    <span slot="no-results"></span>
                                  </infinite-loading>
                                </div>
                            </div>
                            <div v-if="meetNowStatus && meetNowUsers && meetNowUsers.length" class="favorites" id="meet_more_users">
                              <MeetNowSidebar></MeetNowSidebar>
                            </div>
                          <DiscoverTabs></DiscoverTabs>
                          <div class="pagetitle">
                            <h1 v-if="searchBuddyInput.length">{{ trans('search_results') }}</h1>
                            <div v-else-if="usersAround.length">
                            </div>
                          </div>

                            <div id="js-discover-content" class="faces catalog" :class="{'list': viewType === 'list'}">
                                <div class="face" :id="'discover-user-' + user.id" v-for="user in usersAround"
                                    v-on:click="goToProfile(user)"
                                    data-open2="card"
                                    :ref="'userFace'+user.id"
                                    :class="{'meet_now': user.meet_now,'online': user.isOnline, 'was-online': user.wasRecentlyOnline && !user.isOnline, 'favorite': user.isFavorite, 'sensitive': user.photo_small === '/assets/img/toohot_180x180.jpg', 'default-photo': user.photo_small == '/assets/img/default_180x180.jpg'}">
                                    <div class="img" :style="{'background': `url(${user.deleted_at ? trashIcon : user.photo_small}) no-repeat center / cover`}"></div>
                                    <div class="has-videos" v-if="user.has_videos"></div>
                                    <div class="number-indicator" v-if="user.unreadMessagesCount">{{ user.unreadMessagesCount }}</div>
                                    <div class="details">
                                        <div class="name notranslate">{{ user.headline }}</div>
                                        <div class="parameters-box">
                                            <div class="parameters">
                                                <span v-if="user.age">{{ user.age }}</span>
                                                <span v-if="user.height">{{ formatHeight(user.height, false) }}</span>
                                                <span v-if="user.weight">{{ formatWeight(user.weight, false) }}</span>
                                                <span v-if="user.position">{{ transPosition(user.position, true) }}</span>
                                            </div>
                                            <div class="distance" v-if="user.id != authUserId">{{ getDistanceString(user, false) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                          <infinite-loading
                              ref="infiniteLoadingDiscover"
                              @infinite="loadUsersAround"
                              :distance="2500"
                              force-use-infinite-wrapper="#content-wrapper-wrapper"
                              direction="bottom"
                              spinner="bubbles">
                            <span slot="no-more" v-if="!usersNextPageCount">{{ trans(profile.id ? 'no_more_users_around' : 'to_see_members_become_a_member') }}</span>
                            <span slot="no-more" v-if="usersNextPageCount"></span>
                            <span slot="no-results">{{ trans(profile.id ? 'no_more_users_around' : 'to_see_members_become_a_member') }}</span>
                          </infinite-loading>
                          <transition name="fade">
                            <div v-show="showScrollTop" class="scroll_top-button"
                                 @click="scrollToTop()" :title="trans('arrow_scroll_top')">
                                <svg class="icon icon-arrow_up"><use v-bind:xlink:href="symbolsSvgUrl('icon-arrow_up')"></use></svg>
                            </div>
                          </transition>

                        </div>
                        <AddHomeScreen showOn="discover"/>
                        <BottomBar tab="discover"/>
                    </div><!--#application-wrapper-->
                </vue2-gesture>
            </vue2-gesture>
        </div><!--w-views-->
    </div><!--w-root-->
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';
    import InfiniteLoading from 'vue-infinite-loading';
    InfiniteLoading.methods.attemptLoad = function (isContinuousCall) {
      if (
          this.status !== STATUS.COMPLETE
          && isVisible(this.$el)
          && this.getCurrentDistance() <= this.distance
      ) {
        this.status = STATUS.LOADING;

        if (this.direction === 'top') {
          // wait for spinner display
          this.$nextTick(() => {
            scrollBarStorage.save(this.scrollParent);
          });
        }

        if (typeof this.onInfinite === 'function') {
          this.onInfinite.call(null, this.stateChanger);
        } else {
          this.$emit('infinite', this.stateChanger);
        }

        if (isContinuousCall && !this.forceUseInfiniteWrapper && !loopTracker.isChecked) {
          // check this component whether be in an infinite loop if it is not checked
          // more details: https://github.com/PeachScript/vue-infinite-loading/issues/55#issuecomment-316934169
          loopTracker.track();
        }
      } else if (this.status === STATUS.LOADING) {
        this.status = STATUS.READY;
      }
    };
    InfiniteLoading.mounted =   function() {
      console.log('MOUNTED');
      this.$watch('forceUseInfiniteWrapper', () => {
        this.scrollParent = this.getScrollParent();
      }, { immediate: true });

      this.scrollHandler = (ev) => {
        if (this.status === STATUS.READY) {
          if (ev && ev.constructor === Event && isVisible(this.$el)) {
            throttleer.throttle(this.attemptLoad);
          } else {
            this.attemptLoad();
          }
        }
      };

      setTimeout(() => {
        this.scrollHandler();
        this.scrollParent.addEventListener('scroll', this.scrollHandler, evt3rdArg);
      }, 1);

      this.$on('$InfiniteLoading:loaded', (ev) => {
        this.isFirstLoad = false;

        if (this.direction === 'right' || this.direction === 'top') {
          // wait for DOM updated
          this.$nextTick(() => {
            scrollBarStorage.restore(this.scrollParent);
          });
        }

        if (this.status === STATUS.LOADING) {
          this.$nextTick(this.attemptLoad.bind(null, true));
        }

        if (!ev || ev.target !== this) {
          warn(WARNINGS.STATE_CHANGER);
        }
      });

      this.$on('$InfiniteLoading:complete', (ev) => {
        this.status = STATUS.COMPLETE;

        // force re-complation computed properties to fix the problem of get slot text delay
        this.$nextTick(() => {
          this.$forceUpdate();
        });

        this.scrollParent.removeEventListener('scroll', this.scrollHandler, evt3rdArg);

        if (!ev || ev.target !== this) {
          warn(WARNINGS.STATE_CHANGER);
        }
      });

      this.$on('$InfiniteLoading:reset', (ev) => {
        this.status = STATUS.READY;
        this.isFirstLoad = true;
        scrollBarStorage.remove(this.scrollParent);
        this.scrollParent.addEventListener('scroll', this.scrollHandler, evt3rdArg);

        // wait for list to be empty and the empty action may trigger a scroll event
        setTimeout(() => {
          throttleer.reset();
          this.scrollHandler();
        }, 1);

        if (!ev || ev.target !== this) {
          warn(WARNINGS.IDENTIFIER);
        }
      });

      /**
       * change state for this component, pass to the callback
       */
      this.stateChanger = {
        loaded: () => {
          this.$emit('$InfiniteLoading:loaded', { target: this });
        },
        complete: () => {
          this.$emit('$InfiniteLoading:complete', { target: this });
        },
        reset: () => {
          this.$emit('$InfiniteLoading:reset', { target: this });
        },
        error: () => {
          this.status = STATUS.ERROR;
          throttleer.reset();
        },
      };

      if (this.onInfinite) {
        warn(WARNINGS.INFINITE_EVENT);
      }
    };
    InfiniteLoading.methods.getCurrentDistance = function (){
      let distance;

      if (this.direction === 'top') {
        distance = typeof this.scrollParent.scrollTop === 'number'
            ? this.scrollParent.scrollTop
            : this.scrollParent.pageYOffset;
      } else if(this.direction === 'bottom') {
        const infiniteElmOffsetTopFromBottom = this.$el.getBoundingClientRect().top;
        const scrollElmOffsetTopFromBottom = this.scrollParent === window
            ? window.innerHeight
            : this.scrollParent.getBoundingClientRect().bottom;

        distance = infiniteElmOffsetTopFromBottom - scrollElmOffsetTopFromBottom;
      } else if(this.direction === 'right') {
        const infiniteElmOffsetLeftFromRight = this.$el.getBoundingClientRect().left;
        const scrollElmOffsetLeftFromRight = this.scrollParent === window
            ? window.innerWidth
            : this.scrollParent.getBoundingClientRect().right;

        distance = infiniteElmOffsetLeftFromRight - scrollElmOffsetLeftFromRight;
      }
      console.log('DISTANCE',distance,this.scrollParent)
      return distance;

    };

    import BottomBar from '@buddy/views/widgets/BottomBar.vue';
    import AddHomeScreen from '@buddy/views/widgets/AddHomeScreen.vue';
    import FiltersForms from "@discover/views/widgets/FiltersForms.vue";
    import ProfileMenu from "@profile/views/widgets/ProfileMenu.vue";

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    import discoverModule from '@discover/module/store/type';
    import $ from 'jquery'
    import _ from "lodash";
    import Vue from "vue";
    import MeetNowSidebar from "../widgets/MeetNowSidebar.vue";
    import DiscoverTabs from "../widgets/DiscoverTabs.vue";
    import {evt3rdArg, STATUS, WARNINGS} from "vue-infinite-loading/src/config";
    import {isVisible, loopTracker, scrollBarStorage, throttleer, warn} from "vue-infinite-loading/src/utils";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-discover').default
        ],
        props: ['tab'],
        data() {
            return {
                scroll: 0,
                interval:false,
                stopOnlineFavoriteRefresh: false,
                pullToRefreshInstance: null,
                navbarVisible: true,
                disableSwipe: false,
                showScrollTop: false,
                showAgeConfirmModal: false,
                scrollEvent: null,
                disableScrollTop: false,
                scrollTimeout: null,
                currentFilter: null,

                showSearchInput: true,

                searchBuddyInput: '',
                searchTags: [],
                canShowTagsBlock:false,
                searchTagInputActive:false,
                tagsLoading:false,
            }
        },
        components: {
            DiscoverTabs,
            MeetNowSidebar,
            FiltersForms,
            ProfileMenu,
            BottomBar,
            InfiniteLoading,
            AddHomeScreen,
            vueCustomScrollbar
        },
        computed: {
            ...mapState({
                showFavoriteOnline: state => state.discoverModule.showFavoriteOnline,
                sidebar: state => state.sidebar,
                favoritesOnline: state => state.discoverModule.favoritesOnline,
                profile: 'profile',
                user: 'profile',
                haveUnblockedUsers: 'haveUnblockedUsers',
            }),
            ...mapGetters([
                'meetNowStatus',
                'meetNowUsers',
                'discreetModeEnabled',
                'userHasNotifications',
                'userProfile'
            ]),
            meet_now_text(){
              var duration = moment.duration(moment(this.meetNowStatus.expire_at).diff(moment(this.now)));
              var minutes = duration.asMinutes();
              var minutes_string = parseInt(minutes.toString()) + 1;
              return (minutes_string <= window.MEET_NOW_ACTIVE_MIN ? minutes_string : window.MEET_NOW_ACTIVE_MIN);
            },
            defaultPhoto() {
                let avatars = this.profile.avatars
                if (!avatars.adult && (avatars.default?.rejected || avatars.default?.pending)) {
                  return '/assets/img/default_180x180.jpg';
                } else {
                  return _.get(avatars, 'merged.photo_small', '/assets/img/default_180x180.jpg')
                }
            },
            debounceGetScroll: function () {
                return _.debounce(this.checkScroll, 100);
            }
        },
        methods: {
            setScrollFromTag() {
              let url = new URL(location)
              let params = new URLSearchParams(url.search);

              if (params.has('tag')) {
                let tag = params.get('tag')
                let ref = this.$refs['userFace'+tag];

                if (ref && ref.length) {
                  ref = ref[0];

                  if (ref) {
                    console.log('REF DATA');
                    console.log(ref);
                    ref.scrollIntoView();
                  }
                }
              }
            },
            cleanSearch() {
              this.searchBuddyInput = '';
              this.canShowTagsBlock = false;

              this.$nextTick(() => {
                setTimeout(() => {
                  this.searchBuddy();
                });
              });
            },
            ...mapActions([
                'trySwitchDiscreetMode',
                'toggleMeetNow'
            ]),
            showPartiesOn(slot) {
              if (slot) {
                this.showModal();
              }
            },
            closedWelcomeModal() {
              this.updateUserModalSohwn({
                'is_guide_modal_shown': true,
              });
            },
            searchBuddyInputReaction() {
              this.searchTags = [];
              this.tagsLoading = true;
              this.canShowTagsBlock = this.searchBuddyInput.match(/\#(.+)/);

              if (this.canShowTagsBlock) {
                try {
                  axios.get('/api/search_tags', {
                    params: {
                      searchRequest: this.searchBuddyInput,
                    }
                  })
                      .then((response) => {
                        this.searchTags = response.data.tags;
                        this.tagsLoading = false;
                      })
                } catch (e) {
                  console.log(e);
                }
              }
            },
            fillTag(tag) {
              this.searchBuddyInput = '#'+tag.name;

              setTimeout(() => {
                this.canShowTagsBlock = false;
                this.searchBuddy(true);
              }, 200);
            },
            searchBuddyDebounce: _.debounce(function (input) {
              this.searchBuddyInputReaction();

              if (!this.canShowTagsBlock) {
                this.$store.dispatch(discoverModule.actions.filter.set, {
                  key: 'filterName',
                  value: input.target.value,
                  queueRefresh: true
                });
                this.resetUsersAround();
              }
            }, 1000),
            searchBuddy(force=false) {
              if (!this.canShowTagsBlock || force) {
                this.$store.dispatch(discoverModule.actions.filter.set, {
                  key: 'filterName',
                  value: this.searchBuddyInput,
                  refresh: true
                })
              }
            },
            async updateUserModalSohwn(payload) {
              this.$store.commit('updateUser', payload)
              await axios.post('/api/updateUser', payload)
              console.log(`[User] Modal settings setting updated`, { payload })
            },
            showModal () {
              this.$modal.show('welcome-message-modal');
            },
            hideModal () {
              this.$modal.hide('welcome-message-modal');
            },
            checkProFilters() {
                if (!this.userIsPro) {
                    const proFilters = this.$store.getters[discoverModule.getters.filter.proFilters];

                    proFilters.forEach((value) => {
                      let key = `${value}Values`;

                      this.$store.dispatch(discoverModule.actions.filter.remove, {
                        key,
                        refresh: true
                      });
                    })
                }

              Vue.nextTick(() => {
                this.setScrollFromTag();
              })
            },
            setDisableSwipe(value) {
                this.disableSwipe = value;
            },
            onScroll() {
                const vm = this;
                vm.setDisableSwipe(true);
                clearTimeout(vm.scrollTimeout);

                vm.scrollTimeout = setTimeout(function () {
                    vm.setDisableSwipe(false)
                }, 300);
            },
            toggleProfileSidebar(value) {
                if (value === null){
                    value = !this.sidebar.profile.visible
                    if (value) {
                        this.closeFilterSidebar(false)
                    }
                }
                this.$store.dispatch('updateSidebarVisibility', {index: 'profile', value})
            },
            closeFilterSidebar(value) {
              this.$store.dispatch('updateSidebarVisibility', {index: 'filter', value})
            },
            toggleFilterSidebar(value) {
                if (value === null){
                    value = !this.sidebar.filter.visible
                    if (value) {
                        this.toggleProfileSidebar(false)
                    }
                }

                this.$store.dispatch('updateSidebarVisibility', {index: 'filter', value})

                let currentFilter = {}

                let defaultFilters = this.$store.getters[discoverModule.getters.filter.defaultFilter];
                let filter = this.$store.getters[discoverModule.getters.filter.get]

                for (let defaultFilter in defaultFilters) {
                    if (defaultFilter === `${defaultFilter}Values`) {
                        currentFilter[defaultFilter] = filter(`${defaultFilter}Values`)
                    } else {
                        currentFilter[defaultFilter] = filter(defaultFilter)
                    }
                }

                let isChanged = JSON.stringify(this.currentFilter) !== JSON.stringify(currentFilter)

                if (isChanged) {
                  this.$store.dispatch(discoverModule.actions.users.setRefreshQueued, true)
                  this.resetUsersAround()
                  this.currentFilter = currentFilter
                }
            },
            handleGesture(str, e) {
                if (this.disableSwipe) {
                    return;
                }

                if (str == 'swipeLeft') {
                    if (this.sidebar.profile.visible) {
                        //this.toggleProfileSidebar(false)
                    } else {
                        //this.toggleFilterSidebar(true)
                    }
                }
                if (str == 'swipeRight') {
                    if (this.sidebar.filter.visible) {
                        //this.toggleFilterSidebar(false)
                    } else {
                        //this.toggleProfileSidebar(true)
                    }
                }
            },
            goToProfile(user) {
              this.goTo('/user/' + user.id)
              // this.$router.push({ hash: '#userModal='+user.id })
              //this.openUserMobileModal(user.id, 2)
            },
            scrollToTop() {
                if (!this.disableScrollTop) {
                  $('#content-wrapper-wrapper').addClass('disable-scroll');
                  $('#application-wrapper').removeClass('scroll-content');
                  $('#content-wrapper-wrapper').bind('touchmove', function(e){e.preventDefault()})
                  let container = document.getElementById('content-wrapper-wrapper');
                  container.scrollTo({
                    top: 0,
                  })
                }
            },
            prepareScroll(event) {
                let currentScroll = event.target.scrollTop;

                if (currentScroll === 0) {
                    $('#content-wrapper-wrapper').unbind('touchmove')
                    let container = $('#content-wrapper-wrapper')
                    container.removeClass('disable-scroll');
                }

                if (app.isMobile) {
                  $('#application-wrapper').addClass('scroll-content');
                  this.setUsersAroundPosition();
                  this.showScrollTopButton(event);
                  this.scrollEvent = event;
                  this.checkScroll();
                }
            },
            showScrollTopButton(event) {
                let currentScroll = event.target.scrollTop;
                this.showScrollTop = currentScroll >= 370;
            },
            checkScroll() {
              const event = this.scrollEvent;

              if (event) {
                let currentScroll = event.target.scrollTop;
                this.scroll = currentScroll

                if (currentScroll > 5) {
                  if (this.pullToRefreshInstance) {
                    this.pullToRefreshInstance.destroy()
                  }
                } else {
                  this.pullToRefreshInstance = this.attachPullToRefresh('#js-discover-content')
                }

                this.showScrollTop = currentScroll >= 370;
              }
            },
            checkScrollDebounce: _.debounce(function (event) {
                if (event) {
                  let currentScroll = event.target.scrollTop;
                  let scrollHeight = event.target.scrollHeight;
                  let clientHeight = event.target.clientHeight;

                  this.scroll = currentScroll

                  if (currentScroll > 5) {
                    if (this.pullToRefreshInstance) {
                      this.pullToRefreshInstance.destroy()
                    }
                  } else {
                    this.pullToRefreshInstance = this.attachPullToRefresh('#js-discover-content')
                  }

                  // if (currentScroll + clientHeight === scrollHeight) {
                  //   this.$refs.infiniteLoadingDiscover.stateChanger.reset();
                  // }

                  this.showScrollTop = currentScroll >= 370;
                }
            }, 100),
            setScrollToDiscover() {
                let container = document.getElementById('application-wrapper');
                container.addEventListener('scroll', this.checkScrollDebounce, true);
            },
            setUsersAroundPosition() {
                app.prevUsersAroundPosition = this.$refs.mobileScrollTopContainer ? this.$refs.mobileScrollTopContainer.scrollTop : 0
            },
            setMode(mode) {
                this.$store.dispatch(discoverModule.actions.filter.set, {
                    key: 'filterType',
                    value: mode,
                    refresh: true
                })
            },
            pullRefresh(){
                this.$store.dispatch(discoverModule.actions.users.setRefreshQueued, true)
                this.resetUsersAround()
                // this.showSearchInput = true
            },
            removeDisableScroll() {
                $('#application-wrapper').removeClass('disable-scroll');
                this.scroll = 0;
                this.showScrollTop = false;
            },
        },
        watch: {
            userIsPro() {
              this.checkProFilters();
              this.resetUsersAround();
            },
            searchBuddyInput: function(val) {
              this.searchTagInputActive = false;

              this.$nextTick(() => {
                setTimeout(() => {
                  this.searchTagInputActive = val.match(/\#(.+)/);
                }, 50);
              });
            },
        },
        created(){
          console.log('[Discover] Created')
            app.$on('reload-discover', this.resetUsersAround);
            app.$on('show-parties-on', this.showPartiesOn)
          let self = this;
          setInterval(function () {
            if(self.meetNowStatus){
              self.now = Date.now()
            }
          }, 1000)
        },
        mounted() {
            console.log('[Discover] Mounted');
            this.pullToRefreshInstance = this.attachPullToRefresh('#js-discover-content')
            let v = this
            this.checkAgeConfirmModal(function (){
              v.resetUsersAround(true);
            });

            if (app.isDesktop) {
                this.setScrollToDiscover();
            }

            let currentFilter = {};
            let defaultFilters = this.$store.getters[discoverModule.getters.filter.defaultFilter];
            let filter = this.$store.getters[discoverModule.getters.filter.get]

            for (let defaultFilter in defaultFilters) {
                if (defaultFilter === `${defaultFilter}Values`) {
                  currentFilter[defaultFilter] = filter(`${defaultFilter}Values`)
                } else {
                  currentFilter[defaultFilter] = filter(defaultFilter)
                }
            }

            this.currentFilter = currentFilter

            if (this.$route.query.user) {
                this.openUserModal(this.$route.query.user, 4)
            }
            store.dispatch(discoverModule.actions.users.setRefreshQueued, false)

            store.dispatch('showAdminPopUp','radar')

        },
        activated(){
            console.log('[Discover] Activated');

            if (this.isMobile) {
              this.resetUsersAround()
            }

            this.pullToRefreshInstance = this.attachPullToRefresh('#js-discover-content')

            if (app.isDesktop) {
                this.setScrollToDiscover();
            } else {
                if (this.$route.meta.back === '/search' || this.haveUnblockedUsers) {
                    // this.resetUsersAround();
                    this.$store.commit('setHaveUnblockedUsers', false)
                }
            }

            if (!this.userProfile.is_guide_modal_shown) {
              app.$emit('show-parties-on', true)
            }

            this.$nextTick(() => {
              setTimeout(() => {
                this.setScrollFromTag();
              }, 50);
            });
          let self = this;
          this.interval = setInterval(async function (){
            if(self.stopOnlineFavoriteRefresh || !self.profile.id){
              return ;
            }
            self.$store.commit(discoverModule.mutations.setFavoritesOnlinePage, 0)
            if(!self.showFavoriteOnline){
              await self.loadOnlineUsers(null);
              if(!self.favoritesOnline.length){
                return false;
              }
            }
            self.$store.commit(discoverModule.mutations.showFavoriteOnline.set, true)
            self.$store.commit(discoverModule.mutations.favoritesOnline.reset)
            self.$refs.infiniteLoadingFavorites.stateChanger.reset();
          },60000)
        },
        deactivated() {
            this.removeDisableScroll();
          clearInterval(this.interval)
        },
        destroyed() {
            app.$off('reload-discover')
            app.$off('show-parties-on')
        }
    }
</script>
<style scoped>
  .discoverSearchTagsChild {
    width:100% !important;
  }
  .disable-scroll {
      overflow: hidden !important;
  }

  #application-wrapper {
    overflow: visible !important;
  }

  .content-wrapper {
    padding-top: 80px;
    overflow-x: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
  }

</style>

<style>
  .welcome-modal-main {
    width: 85%;
    max-width: 400px;
    position: absolute;
    display: flex;
    align-items: center;
  }

  .welcome-modal-main .inner {
    position: relative;
  }

  .welcome-modal-main .inner .close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 4;
    width: 60px;
    height: 60px;
    background: none;
    cursor: default;
  }

  .welcome-modal-main .inner .close:before {
    content: "";
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(/main/img/icons/close.svg);
    cursor: pointer;
  }

  .welcome-modal-main img {
    border-radius: 7px;
    box-shadow: 10px 10px 10px rgb(0 0 0 / 50%);
  }

  .welcome-modal-title {
    text-align: center;
    font-size: 52px;
    font-weight: bold;
    margin-top: 10%;
    color: white;
    font-family: Arial, Baskerville, monospace;
    line-height: 95%;
  }

  .welcome-modal-content {
    padding-left: 10%;
    padding-right: 10%;
    margin-top: 5%;
    text-align: center;
  }

  .welcome-modal-content p:first-child {
    margin-top: 25px;
  }

  .welcome-modal-content p {
    margin: 15px 0 15px 0;
    padding: 0;
    font-weight: bold;
    line-height: 110%;
    font-size: 20px;
    color: white;
    font-family: Arial, Baskerville, monospace;
  }

  .welcome-modal-top-icon {
    text-align: center;
    width: 100%;
    margin-top: 15%;
  }

  .welcome-modal-top-icon .calendar {
    max-width: 50px;
    max-height: 50px;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.5));
  }

  .welcome-modal-main .like {
    margin-top: 10%;
    text-align: center;
  }

  .welcome-modal-main .like img {
    width: 33px;
    height: 30px;
  }

  .mobilePopup .vm--modal {
    top: 0 !important;
    left: 0 !important;
    background: rgba(0, 0, 0, 0.4);
    width: 100% !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
  }
  
  .clearBothDiscoverSearch {
    clear: both;
    margin-bottom: 55px;
  }
</style>